// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"97f3d188","377":"b55f7cd5","732":"6dba007b","977":"671067b1"}[chunkId] + ".chunk.js";
};